// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2maQJ","legacyBtn":"MutateMid_legacyBtn__1n4H8"};